import React, {Component} from 'react';
import compose from 'recompose/compose';
import {withStyles} from '@material-ui/core/styles';
import queryString from 'query-string';
import {Link} from 'react-router-dom';
import {accessTokenLocalStorageKey, changePasswordEndPoint, resourceCustomUsers} from '../../constants';
import ChangePasswordForm from './ChangePasswordForm';
import {NotificationManager} from 'react-notifications';
import {simpleDataProvider} from '../../fetchApi';
import {FETCH} from '../../fetchApi/types';
import storage from '../../fetchApi/storage';
import {withTranslation} from 'react-i18next';

const styles = {
    changeTabLink: {
        display: 'inline',
        textDecoration: 'underline',
        color: '#FFFFFF'
    },
    suggestion: {
        color: '#FFFFFF',
        fontSize: '14px',
        marginTop: '4px'
    }
};

class ChangePassword extends Component {
    constructor(props) {
        super(props);

        this.state = {
            redirect: null,
            loading: false
        };
    }

    handleResetPassword = (values) => {
        const {t: translate} = this.props;
        const queryParams = queryString.parse(this.props.location.search, {ignoreQueryPrefix: true});

        if (!queryParams.token) {
            NotificationManager.error(translate('forgot_password.invalidResetPasswordCallback'));
            this.redirectToLogin();
            return;
        }

        this.setState({loading: true});
        simpleDataProvider(
            FETCH,
            `${resourceCustomUsers}/${changePasswordEndPoint}`,
            {
                newPassword: values.newPassword,
                token: queryParams.token
            }
        )
            .then(() => {
                NotificationManager.success(translate('forgot_password.password_changed'));
                storage.remove(accessTokenLocalStorageKey);
                this.redirectToLogin();
            })
            .catch(err => {
                NotificationManager.error(err.message);
                this.setState({loading: false});
            });
    };

    redirectToLogin = () => {
        this.props.history.push('/signin');
    };

    render() {
        const {classes, loading, t: translate} = this.props;

        return (
            <div className="rct-session-wrapper" style={{display:'flex'}}>
                <div className="session-inner-wrapper" style={{alignSelf: 'center', width: '100%', transform: 'translate3d(0%, -10%, 0)'}}>
                    <div className="container">
                        <div className="row row-eq-height" style={{flexDirection: 'column'}}>
                            <div className="col-sm-7 col-md-7 col-lg-8">
                                <div className="session-body text-center">
                                    <div className="session-head mb-30">
                                        <h2 className="font-weight-bold">{translate('changePassword.title')}</h2>
                                    </div>
                                    <ChangePasswordForm isLoading={loading} onSubmit={this.handleResetPassword}/>
                                </div>
                            </div>
                            <p className={classes.suggestion}>
                                {translate('common.actions.click')}&nbsp;
                                <Link to="/signin" className={classes.changeTabLink}>
                                    {translate('common.here')}
                                </Link>
                                &nbsp;
                                {translate('common.toLowercase')}&nbsp;
                                {translate('widgets.signIn')}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const EnhancedChangePassword = compose(
    withTranslation(),
    withStyles(styles),
)(ChangePassword);

export default EnhancedChangePassword;